"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[925],{

/***/ 2925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4078);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8757);
/* harmony import */ var hooks_useFetch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9350);
/* harmony import */ var components_BookNow_BookNow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6562);






const PhoneBadge = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(721)]).then(__webpack_require__.bind(__webpack_require__, 7939)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7939)
            ]
    },
    ssr: true
});
const WorkingHours = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 946).then(__webpack_require__.bind(__webpack_require__, 4984)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4984)
            ]
    },
    ssr: true
});
const Socials = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 722).then(__webpack_require__.bind(__webpack_require__, 3722)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3722)
            ]
    },
    ssr: true
});
function Sticky(param) {
    let { profile  } = param;
    const { data: businessProfile  } = (0,hooks_useFetch__WEBPACK_IMPORTED_MODULE_4__/* .useBusinessProfile */ .jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("common");
    const isSocialHasItems = Object.keys(profile.publicLinks || {}).length > 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "col-span-12 lg:col-span-6 xl:col-span-5",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "sticky top-40 shadow-[rgba(0,_0,_0,_0.12)_0px_15px_30px_-12px] p-5 md:p-8 rounded-lg border border-zinc-200 bg-white",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                    className: "absolute top-8 bottom-8 left-1/2 -translate-x-1/2 w-[1px] bg-zinc-200 hidden md:block lg:hidden"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 md:gap-x-16 lg:grid-cols-1 lg:grid-rows-none lg:gap-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-span-2 md:col-span-1 row-span-none md:row-span-1 lg:row-span-none mb-8 md:mb-0 lg:mb-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex align-center gap-3 flex-wrap flex-row md:flex-col lg:flex-row",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex-1",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_BookNow_BookNow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            hasLongTitle: true,
                                            uniqueIdentifier: widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.uniqueIdentifier
                                        })
                                    }),
                                    profile.phoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex-1",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PhoneBadge, {
                                            phoneNumber: profile.phoneNumber
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-span-2 row-span-1 md:col-span-1 md:row-span-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "font-medium text-lg xl:text-xl mb-4",
                                    children: t("workingHours.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WorkingHours, {
                                    workingHours: profile.workingHours
                                })
                            ]
                        }),
                        isSocialHasItems && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-span-2 row-span-1 md:col-span-1 md:row-span-2 mt-8 md:mt-0 lg:mt-8 self-auto md:self-end lg:self-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "font-medium text-lg xl:text-xl mb-4",
                                    children: t("global.socials")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Socials, {
                                    businessName: profile.name,
                                    publicLinks: profile.publicLinks
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Sticky));


/***/ }),

/***/ 6562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8757);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1689);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8728);







function BookNow(param) {
    let { uniqueIdentifier , type , id , buttonWide , hasLongTitle  } = param;
    const { locale  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("common");
    if (!uniqueIdentifier) return null;
    const href = (0,utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .generateBookingURL */ ._2)({
        uniqueIdentifier,
        type,
        id,
        locale
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: href,
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("flex items-center justify-center border border-primary-500 text-sm rounded-lg text-primary-text bg-primary-500 uppercase font-medium hover:bg-primary-300 hover:border-primary-300 transition-colors cursor-pointer", {
            "py-2 px-8": buttonWide
        }, {
            "py-3 px-5": !buttonWide
        }),
        children: hasLongTitle && t("global.booknow") || t("global.book")
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(BookNow));


/***/ })

}]);